export default "__VITE_ASSET__DzUO6URs__";